<template>
  <div class="navbar-container d-flex content align-items-center">
    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link class="nav-link" @click="toggleVerticalMenuActive">
          <feather-icon icon="MenuIcon" size="21" />
        </b-link>
      </li>
    </ul>

    <!-- Left Col -->
    <div
      class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex"
    >
      <!-- Bookmarks Container -->
      <bookmarks />
    </div>

    <b-navbar-nav class="nav align-items-center ml-auto">
      <!-- <dark-Toggler class="d-none d-lg-block" /> -->
      <!-- <cart-dropdown /> -->
      <locale />
      <notification-dropdown />
      <b-nav-item-dropdown
        class="dropdown-notification ml-1"
        menu-class="dropdown-menu-media"
        right
      >
        <template #button-content>
          <feather-icon
            badge="99"
            badge-classes="bg-danger"
            icon="CalendarIcon"
            size="25"
          />
        </template>
        <div class="py-2 px-2">قريبا</div>
      </b-nav-item-dropdown>
      <b-nav-item-dropdown
        class="dropdown-notification ml-1"
        menu-class="dropdown-menu-media"
        right
      >
        <template #button-content>
          <feather-icon
            badge="5"
            badge-classes="bg-danger"
            icon="FileTextIcon"
            size="25"
          />
        </template>
        <div class="py-2 px-2">قريبا</div>
      </b-nav-item-dropdown>
    </b-navbar-nav>
  </div>
</template>

<script>
import { BLink, BNavbarNav, BNavItemDropdown } from "bootstrap-vue";
import Bookmarks from "./components/Bookmarks.vue";
import Locale from "./components/Locale.vue";
// import DarkToggler from './components/DarkToggler.vue'
// import CartDropdown from './components/CartDropdown.vue'
import NotificationDropdown from "./components/NotificationDropdown.vue";

export default {
  components: {
    BLink,
    // Navbar Components
    BNavbarNav,
    Bookmarks,
    Locale,
    // DarkToggler,
    // CartDropdown,
    NotificationDropdown,
    BNavItemDropdown,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
};
</script>
